import { defineMessages } from 'react-intl';

export default {
  ...defineMessages({
    addClassSchedule: {
      id: 'schedules.add-class-schedule',
      defaultMessage: 'Add class schedule',
    },
    done: {
      id: 'schedules.done',
      defaultMessage: 'Done',
    },
    notSupported: {
      id: 'schedules.not-supported',
      defaultMessage: 'This feature is currently not supported for this venue.',
    },
  }),
  board: {
    ...defineMessages({
      title: {
        id: 'schedules.board.title',
        defaultMessage: 'Class schedule',
      },
    }),
    empty: defineMessages({
      noSchedules: {
        id: 'schedules.board.empty.no-schedules',
        defaultMessage: 'No schedules added yet',
      },
      addFirst: {
        id: 'schedules.board.empty.add-first',
        defaultMessage: 'Add your first schedule to get started',
      },
      noFilteredSchedules: {
        id: 'schedules.board.empty.no-filtered-schedules',
        defaultMessage: 'Schedules for specified filters do not exist.',
      },
    }),
    filters: defineMessages({
      selectedStatuses: {
        id: 'schedules.board.filters.selected-statuses',
        defaultMessage: '{count, plural, one {# status} other {# statuses}}',
      },
      selectedTypes: {
        id: 'schedules.board.filters.selected-types',
        defaultMessage: '{count, plural, one {# type} other {# types}}',
      },
      published: {
        id: 'schedules.board.filters.published',
        defaultMessage: 'Published',
      },
      drafts: {
        id: 'schedules.board.filters.drafts',
        defaultMessage: 'Drafts',
      },
      disabled: {
        id: 'schedules.board.filters.disabled',
        defaultMessage: 'Disabled',
      },
      recurring: {
        id: 'schedules.board.filters.recurring',
        defaultMessage: 'Recurring',
      },
      oneTime: {
        id: 'schedules.board.filters.one-time',
        defaultMessage: 'One-time',
      },
    }),
    list: defineMessages({
      headerTime: {
        id: 'schedules.board.list.header-time',
        defaultMessage: 'Time',
      },
      headerClass: {
        id: 'schedules.board.list.header-class',
        defaultMessage: 'Class',
      },
      headerInstructor: {
        id: 'schedules.board.list.header-instructor',
        defaultMessage: 'Staff',
      },
      headerSchedule: {
        id: 'schedules.board.list.header-repeat-on',
        defaultMessage: 'Repeat on',
      },
    }),
    preview: defineMessages({
      placeholder: {
        id: 'schedules.board.preview.placeholder',
        defaultMessage: 'Select a class to view its details',
      },
      time: {
        id: 'schedules.board.preview.time',
        defaultMessage: 'Time',
      },
      durationWithUnit: {
        id: 'schedules.board.preview.duration-with-unit',
        defaultMessage: '{duration}m',
      },
      duration: {
        id: 'schedules.board.preview.duration',
        defaultMessage: 'Duration',
      },
      instructor: {
        id: 'schedules.board.preview.instructor',
        defaultMessage: 'Staff',
      },
      date: {
        id: 'schedules.board.preview.date',
        defaultMessage: 'Date',
      },
      cpSpots: {
        id: 'schedules.board.preview.cp-spots',
        defaultMessage: 'CP spots',
      },
      schedule: {
        id: 'schedules.board.preview.repeat-on',
        defaultMessage: 'Repeat on',
      },
      recurring: {
        id: 'schedules.board.preview.recurring',
        defaultMessage: 'Recurring',
      },
      oneTime: {
        id: 'schedules.board.preview.one-time',
        defaultMessage: 'One-time',
      },
      scheduleType: {
        id: 'schedules.board.preview.class-type',
        defaultMessage: 'Class type',
      },
      edit: {
        id: 'schedules.board.preview.edit',
        defaultMessage: 'Edit class schedule',
      },
      cancelScheduleInstance: {
        id: 'schedules.board.preview.cancel-schedule-instance',
        defaultMessage: 'Cancel this class',
      },
      editScheduleInstance: {
        id: 'schedules.board.preview.edit-schedule-instance',
        defaultMessage: 'Edit this class',
      },
    }),
    row: defineMessages({
      duration: {
        id: 'schedules.board.row.duration',
        defaultMessage: '{duration}m',
      },
      statusDraft: {
        id: 'schedules.board.row.status-draft',
        defaultMessage: 'Draft',
      },
      statusCancelled: {
        id: 'schedules.board.row.status-canceled',
        defaultMessage: 'Canceled',
      },
      statusDatePassed: {
        id: 'schedules.board.row.status-date-passed',
        defaultMessage: 'Date passed',
      },
    }),
  },
  saga: {
    success: defineMessages({
      scheduleDeleted: {
        id: 'schedules.saga.success.schedule-deleted',
        defaultMessage: 'Schedule was successfully deleted.',
      },
      scheduleAdded: {
        id: 'schedules.saga.success.schedule-added',
        defaultMessage:
          'Schedule was successfully added. Note: only the next two weeks will appear in the “Daily Schedule” section of this dashboard.',
      },
      scheduleEdited: {
        id: 'schedules.saga.success.schedule-edited',
        defaultMessage:
          'Schedule was successfully edited. Note: only the next two weeks will appear in the "Daily Schedule" section of this dashboard.',
      },
      classAdded: {
        id: 'schedules.saga.success.class-added',
        defaultMessage: 'Class was successfully added. You can now create schedules for this class.',
      },
      classEdited: {
        id: 'schedules.saga.success.class-edited',
        defaultMessage: 'Class was successfully updated.',
      },
      instructorAdded: {
        id: 'schedules.saga.success.instructor-added',
        defaultMessage: 'Staff was successfully added.',
      },
      scheduleInstanceCancelled: {
        id: 'schedules.saga.success.schedule-instance-canceled',
        defaultMessage: '{scheduleName} has been canceled.',
      },
      scheduleInstanceEdited: {
        id: 'schedules.saga.success.schedule-instance-edited',
        defaultMessage: '{scheduleName} was successfully edited.',
      },
    }),
    error: defineMessages({
      notSupported: {
        id: 'schedules.saga.error.not-supported',
        defaultMessage: 'This feature is currently not supported for this venue.',
      },
      problemWithRequest: {
        id: 'schedules.saga.error.problem-with-request',
        defaultMessage: 'There was a problem with your request.',
      },
      validationFailed: {
        id: 'schedules.saga.error.validation-failed',
        defaultMessage: 'Please review the schedule details and try again.',
      },
      deleteOneTimeScheduleWithActiveReservations: {
        id: 'schedules.saga.error.delete-one-time-w-reservations',
        defaultMessage: 'Cannot delete one-time schedule with active reservations.',
      },
      deleteOneTimeScheduleInThePast: {
        id: 'schedules.saga.error.delete-one-time-in-the-past',
        defaultMessage: 'Cannot delete one-time schedule that has already taken place.',
      },
      classNameConflict: {
        id: 'schedules.saga.conflict.name',
        defaultMessage:
          "Oops! Looks like you've already created a class with this name. Please input a unique name for your class to avoid any confusion.",
      },
      lastReservationError: {
        id: 'schedules.saga.error.last-reservation',
        defaultMessage:
          'Whoops! It looks like you have an active reservation for this class schedule on {lastReservationDate, date, short}. Please cancel this reservation or ensure your end date falls after this reservation.',
      },
    }),
    validationErrors: defineMessages({
      INVALID_DURATION: {
        id: 'schedules.saga.validation-errors.invalid-duration',
        defaultMessage: 'Invalid duration',
      },
      INVALID_VALUE: {
        id: 'schedules.saga.validation-errors.invalid-value',
        defaultMessage: 'Invalid value',
      },
      INVALID_DAY: {
        id: 'schedules.saga.validation-errors.invalid-day',
        defaultMessage: 'Invalid repeat on days',
      },
      INVALID_CAPACITY: {
        id: 'schedules.saga.validation-errors.invalid-capacity',
        defaultMessage: 'Invalid capacity',
      },
      INVALID_CLASS_ID: {
        id: 'schedules.saga.validation-errors.invalid-class',
        defaultMessage: 'Invalid class',
      },
      INVALID_NUMBER_SPOTS: {
        id: 'schedules.saga.validation-errors.invalid-number-spots',
        defaultMessage: 'Invalid spots',
      },
      INVALID_START_DATE_RANGE: {
        id: 'schedules.saga.validation-errors.invalid-start-date-range',
        defaultMessage: 'Schedule would never occur because of the specified start date',
      },
      END_DATE_TOO_FAR: {
        id: 'schedules.saga.validation-errors.end-date-too-far',
        defaultMessage: 'End date is too far in the future',
      },
      PAST_END_DATE: {
        id: 'schedules.saga.validation-errors.past-end-date',
        defaultMessage: 'End date cannot be in the past',
      },
      START_DATE_TOO_FAR: {
        id: 'schedules.saga.validation-errors.start-date-too-far',
        defaultMessage: 'Start date is too far in the future',
      },
      END_DATE_BEFORE_START_DATE: {
        id: 'schedules.saga.validation-errors.end-date-before-start-date',
        defaultMessage: 'End date cannot be before start date',
      },
      START_DATE_LOCKED: {
        id: 'schedules.saga.validation-errors.start-date-locked',
        defaultMessage: 'It is not possible to change the start date of a published schedule',
      },
      CLASS_LOCKED: {
        id: 'schedules.saga.validation-errors.class-locked',
        defaultMessage: 'It is not possible to change the class of a published schedule',
      },
      RECURRENCE_TYPE_LOCKED: {
        id: 'schedules.saga.validation-errors.recurrence-type-locked',
        defaultMessage: 'It is not possible to change the class type of a published schedule',
      },
      RECURRENCE_RESULTS_IN_NO_OCCURRENCES: {
        id: 'schedules.saga.validation-errors.recurrence-results-in-no-occurences',
        defaultMessage: 'This recurring schedule does not repeat on days between the start date and end date',
      },
    }),
    terminationTypes: defineMessages({
      delete: {
        id: 'schedules.saga.termination-types.delete',
        defaultMessage: 'Class schedule was successfully deleted.',
      },
      end_after_last_active_reservation: {
        id: 'schedules.saga.termination-types.end-after-last-reservation',
        defaultMessage: 'Class schedule will be ended on {endDate, date, short}.',
      },
      end_now: {
        id: 'schedules.saga.termination-types.end-now',
        defaultMessage: 'Class schedule has been ended on {endDate, date, short}.',
      },
    }),
  },
};
